/**
 * Swipeable Volier slider: a native scroll-snap track ([data-track]) plus a progress bar
 * ([data-progress]) and optional prev/next buttons ([data-prev], [data-next]).
 */
class VolierSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.progress = this.querySelector('[data-progress]');
    this.prev = this.querySelector('[data-prev]');
    this.next = this.querySelector('[data-next]');
    if (!this.track) return;

    this.update = this.update.bind(this);
    this.track.addEventListener('scroll', this.update, { passive: true });
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.track);

    this.prev?.addEventListener('click', () => this.step(-1));
    this.next?.addEventListener('click', () => this.step(1));

    this.onBlockSelect = (event) => {
      if (this.track.contains(event.target)) {
        event.target.closest('[data-slide]')?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    };
    document.addEventListener('shopify:block:select', this.onBlockSelect);

    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  step(direction) {
    const slide = this.track.querySelector('[data-slide]');
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const distance = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth;
    this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const max = scrollWidth - clientWidth;
    const scrollable = max > 2;
    this.toggleAttribute('data-static', !scrollable);

    if (this.progress) {
      const visible = scrollWidth ? clientWidth / scrollWidth : 1;
      const offset = max > 0 ? (scrollLeft / max) * (1 - visible) : 0;
      this.progress.style.width = `${visible * 100}%`;
      this.progress.style.transform = `translateX(${(offset / visible) * 100}%)`;
    }
    if (this.prev) this.prev.disabled = scrollLeft <= 2;
    if (this.next) this.next.disabled = scrollLeft >= max - 2;
  }
}

if (!customElements.get('volier-slider')) customElements.define('volier-slider', VolierSlider);
